import axios from "axios";
const packageJson = require("../../package.json");

import crypto from "crypto-js";

const SECRET_KEY = "5d928cd2-77d1-4415-growniverse-4f225f40ee65";

function generateSignature(payload) {
  const timestamp = Date.now().toString();
  const data = `${payload}|${timestamp}`;
  const signature = crypto.HmacSHA256(data, SECRET_KEY).toString(crypto.enc.Hex);
  return { signature, timestamp };
}

// Create a global axios instance
const api = axios.create({
  baseURL: packageJson.apiUrl,
});

// Interceptor to inject headers globally
api.interceptors.request.use((config) => {
  debugger
  const payload = config.url;
  const { signature, timestamp } = generateSignature(payload);
  const profile = localStorage.getItem("userProfile");
  let userInformationId = null;

  if (profile) {
    try {
      const parsed = JSON.parse(profile);
      userInformationId = parsed.userInformationId;
    } catch (err) {
      console.error("Failed to parse userProfile:", err);
    }
  }

  config.headers["X-Growniverse-Signature"] = signature;
  config.headers["X-Growniverse-Timestamp"] = timestamp;
  const appKey = localStorage.getItem("appkey");
  config.headers["X-Growniverse-Appkey"] = appKey;
  if (userInformationId) {
    config.headers["X-Growniverse-UserInformationId"] = userInformationId;
  }

  return config;
});

export default api;
